module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"caption":"Didascalia","addImages":"Aggiungi immagine o video","editImage":"Modifica immagine o video","editGallery":"Modifica gallery","htmlInfoBlock":"HtmlInfoBlock","infoBlockLink":"InfoBlock Link","showInfoBlock":"Mostra InfoBlock?","videoId":"Youtube Video Id","dialogData":{"image":"Immagine","video":"Video"}}}')
  delete Component.options._Ctor
}
